import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { Button } from "../../../../components/Buttons";

export const Search = () => {
    document.title = "Sürətli axtarış";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Sürətli axtarış", value: "/products/parameters/search", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sürətli axtarış</h2>
                    <p>
                        Məhsulun adı, barkodu, art kodu, məhsula yazılan şərhə görə sürətli axtaış etmək üçün nəzərdə tutulub. Axtarış, yazı yazılan kimi
                        avtomatik olaraq baş verir. Həmçinin <Button>Enter</Button> düyməsini də sıxıb axtarış etmək olar.
                    </p>
                    <img src="/images/products/parameters/search.gif" alt="Sürətli axtarış" />
                </article>
            </div>
        </div>
    );
};
